module.exports = __webpack_public_path__ + "static/media/hash.0e046d0a.svg";